import { getAllUrlParams, customTime, eventsService, AppEvents } from '@Engage.Core';
import { NewsletterStorage } from '@Engage.Data/services/storage/NewsletterStorage';
const SOURCE_PARAM = 'g2i_source';
const ENCRYPTED_EMAIL_PARAM = 'g2i_eui';
const CAMPAIGN_PARAM = 'g2i_campaign';
const NEWSLETTER_SOURCE_VALUE = 'newsletter';
/**
 * Mirrors ConneXt v2 NewsletterClient.processParams().
 * When a user arrives via a newsletter link (g2i_source=newsletter),
 * sets nxt_nl_source (cookie) and nxt_nl_reader (localStorage).
 */
export class NewsletterArrivalHandler {
    static process() {
        const params = getAllUrlParams();
        if (!this.isCameFromNewsletter(params))
            return;
        this.setNewsletterSource(params);
        this.setNewsletterReader();
        // Dispatch NewsletterArrival � mirrors Connext v2 NewsletterClient.fireNewsletterArrival()
        eventsService.dispatch(AppEvents.NewsletterArrival, {
            Source: NEWSLETTER_SOURCE_VALUE,
            EncryptedEmail: params[ENCRYPTED_EMAIL_PARAM] || null,
            Campaign: params[CAMPAIGN_PARAM] || null
        });
    }
    static isCameFromNewsletter(params) {
        var _a;
        return ((_a = params === null || params === void 0 ? void 0 : params[SOURCE_PARAM]) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === NEWSLETTER_SOURCE_VALUE;
    }
    static setNewsletterSource(params) {
        const value = {
            [ENCRYPTED_EMAIL_PARAM]: params[ENCRYPTED_EMAIL_PARAM] || null,
            [CAMPAIGN_PARAM]: params[CAMPAIGN_PARAM] || null
        };
        NewsletterStorage.setNewsletterSource(value);
    }
    static setNewsletterReader() {
        NewsletterStorage.setNewsletterReader(customTime.get().toISOString());
    }
}
